var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-menu-list"},[_c('ul',{staticClass:"link-wrap noselect"},_vm._l((_vm.list),function(opt,i){return _c('MenuItem',{key:opt.url+i,attrs:{"data":opt,"remindShow":opt.remindShow}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4da65f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/pages/home/common-menu-card/menu-list/index.vue
// module id = null
// module chunks = 